import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'durationTranslate',
    pure: false,
    standalone: false
})
export class DurationTranslatePipe implements PipeTransform {
  constructor(
          private translateService: TranslateService
        ) {}
  transform(value: string): string {
    const parts = value?.split(' ');
    return parts?.reduce((prev, next, i) => {
        switch (parts[i]) {
          case 'second':
          case 'second(s)':
          case 'seconds':
            prev += `${parts[i - 1]} ${this.translateService.instant('COMMON.SECOND_S')} `;
            return prev;

          case 'minute':
          case 'minute(s)':
          case 'minutes':
            prev += `${parts[i - 1]} ${this.translateService.instant('COMMON.MINUTE_S')} `;
            return prev;

          case 'hour':
          case 'hour(s)':
          case 'hours':
            prev += `${parts[i - 1]} ${this.translateService.instant('COMMON.HOUR_S')} `;
            return prev;

          case 'day':
          case 'day(s)':
          case 'days':
            prev += `${parts[i - 1]} ${this.translateService.instant('COMMON.DAY_S')} `;
            return prev;

          case 'month':
          case 'month(s)':
          case 'months':
            prev += `${parts[i - 1]} ${this.translateService.instant('COMMON.MONTH_S')} `;
            return prev;
          default:
            prev += '';
            return prev;
        }
    }, '');

  }
}
